import { Component, OnInit, inject } from '@angular/core';
import {AccessService} from '../services/access.service';
import {DataService} from "../services/data.service";
import {LocalStorageService} from "../services/local-storage.service";
import {Router, RouterLink} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {environment} from "../../environments/environment";
import {ThemeService } from '../services/theme.service';
import { GlobalSearchComponent } from './global-search.component';

@Component({
    selector: 'app-navigation',
    imports: [FormsModule, RouterLink, GlobalSearchComponent],
    styles: `
        .navbar-brand {
            padding-top: .75rem;
            padding-bottom: .75rem;
            //background-color: rgba(0, 0, 0, .25);
            //box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
        }

        .navbar .navbar-toggler {
            top: .25rem;
            right: 1rem;
        }

        .navbar .form-control {
            padding: .75rem 1rem;
        }

        .form-control-dark {
            color: #fff;
            background-color: rgba(255, 255, 255, .1);
            border-color: rgba(255, 255, 255, .1);
        }

        .form-control-dark:focus {
            border-color: transparent;
            box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
        }
    `,
    template: `
        <nav class="navbar navbar-expand-lg border-bottom fixed-top" [class.navbar-dark]="isDarkMode" [class.navbar-light]="!isDarkMode">
            <div class="container-fluid">
                <!-- Mobile sidebar toggler -->
                <button class="navbar-toggler d-lg-none me-2" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle sidebar">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <!-- Mobile brand -->
                <a class="navbar-brand d-md-none d-lg-none me-auto py-0" [routerLink]="['/dashboard']">
                    <div class="d-flex">
                        <div class="flex-shrink-0">
                            <img [src]="'assets/img/favicon/' + accessService.client.slug + '/android-chrome-192x192.png'" alt="Logo" class="ms-2" style="height: 40px">
                        </div>
                        <div class="flex-grow-1 ms-3 mt-2">
                            <h5 class="fw-bold mb-0">{{ accessService.client.name }} <small class="text-muted fw-normal" style="font-size: 0.8rem">Management Cockpit</small></h5>
                        </div>
                    </div>
                </a>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <form class="ms-auto d-none d-lg-flex align-items-center gap-2">
                        @if (currentApplicationVersion.endsWith('dev') || currentApplicationVersion.endsWith('local')) {
                            <span class="navbar-text me-3 ms-auto">
                                <div class="alert alert-danger py-1 mb-0" role="alert">TESTUMGEBUNG</div>
                            </span>
                        }
                        <!-- Global Search - Desktop -->
                        <div class="mx-auto d-none d-lg-block me-3">
                            <app-global-search/>
                        </div>

                        <button class="btn btn-sm me-3" type="button" (click)="toggleTheme()" [class.btn-primary]="isDarkMode" [class.btn-outline-secondary]="!isDarkMode" title="Design umschalten">
                            <i class="fa" [class.fa-sun]="isDarkMode" [class.fa-moon]="!isDarkMode"></i>
                            <span class="ms-1 d-none d-xl-inline">{{ isDarkMode ? 'Hell' : 'Dunkel' }}</span>
                        </button>
                        <span class="navbar-text me-3">
                            <h6 class="mb-0"><span class="badge text-bg-secondary">v{{currentApplicationVersion}}</span></h6>
                        </span>
                        <span class="navbar-text me-3 cursor-pointer" [routerLink]="['/settings']">
                            {{ accessService.user.firstname }} {{ accessService.user.lastname }}
                        </span>
                        <button class="btn btn-outline-secondary" type="button" (click)="logout()">Abmelden</button>
                    </form>
                </div>
            </div>
        </nav>
    `
})
export class NavigationComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);
    private themeService = inject(ThemeService);

    currentApplicationVersion = environment.appVersion;

    ngOnInit(): void {
        // Theme is initialized by ThemeService
    }

    get isDarkMode(): boolean {
        return this.themeService.isDarkMode;
    }

    toggleTheme(): void {
        this.themeService.toggleTheme();
    }

    logout(): void {
        this.dataService.request("User/logout").subscribe(() => {
            this.localStorageService.removeItem('token');
            this.accessService.token = '';
            this.accessService.user = null;
            this.router.navigate(['/login']);
        });
    }

}
